import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  link: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  rowText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: '0em',
    maxWidth: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headText: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    letterSpacing: '0em',
  },
  chip: {
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  activeChip: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  inactiveChip: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  expiredChip: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
  },
}))

export default styles
